var render, staticRenderFns
import script from "./basic_form.vue?vue&type=script&lang=js&"
export * from "./basic_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d955408a')) {
      api.createRecord('d955408a', component.options)
    } else {
      api.reload('d955408a', component.options)
    }
    
  }
}
component.options.__file = "found/views/cps/views/treety/treeties/detail/basic_form.vue"
export default component.exports